function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Outline_Old_Icons",
  "data-name": "Outline Old Icons"
}, React.createElement("path", {
  d: "M14.5,0A14.5,14.5,0,1,0,29,14.5,14.51,14.51,0,0,0,14.5,0Zm0,28A13.5,13.5,0,1,1,28,14.5,13.52,13.52,0,0,1,14.5,28ZM21,14.19a.5.5,0,0,1-.5.5H9.74l4.11,4a.5.5,0,0,1-.35.86.54.54,0,0,1-.35-.14l-5-4.81h0a.6.6,0,0,1-.09-.13l0,0s0,0,0-.05a.58.58,0,0,1,0-.14H8s0,0,0-.07A.35.35,0,0,1,8,14a.29.29,0,0,1,.07-.12l0,0h0l4.49-4.69a.5.5,0,0,1,.72.7L9.67,13.69H20.5A.5.5,0,0,1,21,14.19Z"
})));

var SvgArrowLeftO = function SvgArrowLeftO(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 29 29",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgArrowLeftO, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-left-o.61f02a9a.svg";
export { ForwardRef as ReactComponent };